import { useApi } from "@utils/useApi";
import {
  RecurringServicesContractBurndownDto,
  RecurringServicesContractsClient,
} from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";

export const getContractBurndown = (contractId?: number) => {
  const api = useApi(RecurringServicesContractsClient);

  const getBurndownByContractId = async () => {
    return await api.getContractBurndown(contractId);
  };

  return useQuery<RecurringServicesContractBurndownDto, Error>({
    queryKey: [`recurring-service-contract-burndown-${contractId}`],
    queryFn: getBurndownByContractId,
    enabled: contractId != null,
  });
};
